import React from 'react';
import { Settings } from '@pascal/pascal-core/table-line';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import { CARD_BACKSIDE_TYPES, CARD_VIEW_TYPES } from '../../enums/cardTypes';
import { cardsStore } from '../../store/cardsStore';

export const SettingsContainer = observer(() => {
  const {
    selectedCardBackSideType,
    selectedCardType,
    setSelectedCardBackSideType,
    setSelectedCardType,
  } = cardsStore;
  const t = useTranslation();

  return (
    <Settings hasAnimation>
      <div className='pgc-setting-row'>
        <div className='pgc-setting-row-column left'>
          <span className='pgc-setting-name'>{t('CARDS')}</span>
        </div>
        <div className='pgc-setting-row-column right'>
          <div className='pgc-setting-cards'>
            {Object.values(CARD_VIEW_TYPES).map((item) => (
              <div
                onClick={() => setSelectedCardType(item)}
                className={`pgc-setting-card card-As ${item} ${
                  item === selectedCardType ? 'active' : ''
                }`}
              />
            ))}
          </div>
        </div>
      </div>
      <div className='pgc-setting-row'>
        <div className='pgc-setting-row-column left'>
          <span className='pgc-setting-name'>{t('CARDS_BACKS')}</span>
        </div>
        <div className='pgc-setting-row-column right'>
          <div className='pgc-setting-cards'>
            {Object.values(CARD_BACKSIDE_TYPES).map((item) => (
              <div
                onClick={() => setSelectedCardBackSideType(item)}
                className={`pgc-setting-card ${item} ${
                  item === selectedCardBackSideType ? 'active' : ''
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </Settings>
  );
});
